import React, { useState } from "react";
import "./About.css";
import ContactModal from "./ContactModal.js";
import TechLogos from "./TechLogos .js";

const About = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="about-section">
      <h2 className="about-title">À propos</h2>

      <p className="about-intro">
        <strong>
          Bonjour, je suis Rajo Mampionona Rakotoniaina, développeur web
          fullstack freelance basé à Antananarivo.
        </strong>
        Depuis plus de 8 ans, j’accompagne entrepreneurs, PME et associations
        dans la création, l’évolution et la digitalisation de leurs outils
        métiers.
      </p>
      <p className="about-intro">
        Ma passion pour le numérique m’a conduit à explorer de nombreux
        domaines : développement web (PHP, JavaScript, Python), intégration
        avancée de solutions ERP (Odoo v16 Community & Enterprise, Zoho),
        création de sites vitrines et e-commerce, mais aussi administration
        systèmes et réseaux.
      </p>
      <p className="about-intro">
        <strong>Mon approche :</strong> comprendre en profondeur les besoins de
        chaque client, proposer des solutions sur-mesure et accompagner
        durablement la transformation digitale de leur activité. Je privilégie
        l’écoute, la pédagogie et la transparence, pour instaurer une relation
        de confiance et garantir la réussite de chaque projet.
      </p>
      <div className="about-skills">
        <h3>Ce que je peux vous apporter :</h3>
        <ul>
          <li>
            <strong>Développement d’applications web</strong> : sites vitrines,
            e-commerce, plateformes métier, avec un souci constant de
            performance, sécurité et évolutivité.
          </li>
          <li>
            <strong>Intégration et personnalisation d’ERP</strong> : Odoo v16,
            Zoho CRM, automatisation de workflows, création de modules
            spécifiques.
          </li>
          <li>
            <strong>Expertise CMS</strong> : WordPress (Oxygen, Elementor,
            WPBakery), Prestashop, Joomla, développement de thèmes et plugins
            sur-mesure, optimisation SEO et accessibilité.
          </li>
          <li>
            <strong>Gestion d’hébergement et administration systèmes</strong> :
            configuration de serveurs (Cpanel, firewall, stockage, VoIP),
            supervision, sécurisation et maintenance proactive.
          </li>
          <li>
            <strong>Formation & support</strong> : accompagnement des
            utilisateurs, documentation claire, assistance réactive.
          </li>
        </ul>
      </div>
      <p className="about-conclusion">
        <strong>En veille permanente</strong> sur les évolutions technologiques,
        je me forme régulièrement via des cours en ligne (Coursera, Udemy,
        Elephorm), des certifications et la participation à des webinaires tech.
        Cette curiosité me permet d’apporter à mes clients des solutions
        innovantes, robustes et adaptées à leurs enjeux.
      </p>
      <div className="about-cta about-cta-centered">
        <span>
          Vous souhaitez optimiser vos outils métiers, digitaliser vos processus
          ou développer une application sur-mesure ?
        </span>
        <br />
        <button
          className="about-contact-btn"
          onClick={() => setShowModal(true)}
        >
          Discutons-en !
        </button>
      </div>
      <TechLogos />
      <ContactModal show={showModal} onClose={() => setShowModal(false)} />
    </section>
  );
};

export default About;
